export default "__VITE_ASSET__4699f091__"